import React from "react";
import ReactTable from "react-table-6";
import $ from 'jquery';
import "react-table-6/react-table.css";
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';
import { createTreeList } from '../GetDomains';

class Domains extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: {},
      inEditState: false,
      isRefreshed: true,
      data: [{ name: '', description: '', _subRows: [{ name: '', description: '' }] }],
      currentParentId: '',
      currentParentName: '',
      showAddDomainPopup: false,
      showAddChildPopup: false,
      editedId: '-1',
      fields: {},
      errors: {},
      editedId: '-1',
      showLoader: false,
      hideDeletePopup: false,
      disableAddSubCat: false,
      projectGlobalDomain: "",
      enableEdit: true
    };

    this.dropDownData = [];
    this.editImageSrc = "./assets/images/edit2.png";
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";

    this.dialogClose = () => {
      this.setState({
        hideDeletePopup: false,
      });
    };

    this.settings = { effect: 'Zoom', duration: 600, delay: 0 };

    //for delete dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': (props) => {
        this.deleteDomainApi(this.state.propsId)
      }
    },
    {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({ hideDeletePopup: false });
      }
    }];

    this.columns = []
  }

  componentDidMount() {
    setTimeout(() => {
      this.fetchDomainsOfTheProjectApi();
      this.fetchProjectDomainApi();
    }, 300);
    var thisController = this;
    document.addEventListener("keydown", this.escFunction, false);
    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      thisController.fetchDomainsOfTheProjectApi(event.projectId);
      thisController.fetchProjectDomainApi(event.projectId);
    });
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  escFunction = (event) => {
    if (event.keyCode === 27) {
      if (this.state.showAddDomainPopup) {
        this.state.errors = {};
        this.state.fields = {};
        this.state.showAddDomainPopup = false;
        this.setState(this.state);
        this.newDomainFormRef.reset()
      }
      if (this.state.showAddChildPopup) {
        this.state.errors = {};
        this.state.fields = {};
        this.setState({ showAddChildPopup: false });
        this.setState(this.state);
        this.childFormRef.reset();
      }
    }
  }

  fetchProjectDomainApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var thisController = this;
    $.ajax({
      url: "/api/project-domain",
      async: false,
      method: 'GET',
      data: {
        "projectId": projectId
      },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          thisController.state.projectGlobalDomain = res.result;
          thisController.setState(thisController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  fetchDomainsOfTheProjectApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    let data = { projectId: projectId }
    let thisController = this;
    $.ajax({
      url: "/api/project-categories",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer" + localStorage.getItem("access_token")
      },
      data: data,
      success: function (res) {
        if (res.success === true) {
          thisController.dropDownData = createTreeList(res["result"]);
          thisController.dropDownData.push({ "domain": "None", "domainId": "00000000-0000-0000-0000-000000000000" });
          thisController.state.inEditState = false;
          var treeData = thisController.createTreeForSubChild(res["result"]);
          thisController.state.data = treeData;
          thisController.state.showLoader = true;
          thisController.state.editedId = "-1";
          thisController.setState(thisController.state);
        } else {
          thisController.notifyFailToLoadDomain(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  createTreeForSubChild = (data) => {
    var idRowMap = [];
    var domain;
    var parentDomain;
    var topLevel = [];
    const nullParent = "00000000-0000-0000-0000-000000000000";

    for (var i = 0; i < data.length; i++) {
      domain = data[i];
      idRowMap[domain.id] = domain;
      domain._subRows = [];
    }

    for (var i = 0; i < data.length; i++) {
      domain = idRowMap[data[i].id];
      if (domain.parentId != nullParent) {
        parentDomain = idRowMap[domain.parentId];
        parentDomain._subRows.push(domain);
      }
      if (domain.parentId == nullParent) {
        topLevel.push(domain);
      }
    }
    return topLevel;
  }

  handleChangeForInputData = (e) => {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({ fields });
  }

  notifyDomainUpdated() {
    toast.dismiss();
    toast(<b><img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Domain Updated Successfully</b>, {
      position: "top-center",
    });
  }

  notifyDomainAdded() {
    toast.dismiss();
    toast(<b><img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Domain Added Successfully</b>, {
      position: "top-center",
    });
  }

  notifyChildDomainAdded() {
    toast.dismiss();
    toast(<b><img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Child Domain Added Successfully</b>, {
      position: "top-center",
    });
  }

  saveDomainApi = () => {
    let data = {
      "name": this.state.fields.name,
      "description": this.state.fields.description,
      "projectId": localStorage.getItem("currentProjectId")
    }
    if (this.validateDomainInputsInForm()) {
      let thisController = this;
      $.ajax({
        url: "/api/project-categories",
        type: 'POST',
        async: false,
        headers: {
          "Authorization": "Bearer" + localStorage.getItem("access_token"),
          "Content-Type": "application/json"
        },
        data: JSON.stringify(data),
        success: function (res) {
          if (res.success === true) {
            thisController.fetchDomainsOfTheProjectApi();
            thisController.state.showAddDomainPopup = false;
            thisController.notifyDomainAdded();
            thisController.setState(thisController.state);
          } else {
            thisController.notifyFailToLoadDomain(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        }
      });
      thisController.state.fields = {};
      thisController.state.errors = {};
      thisController.setState(thisController.state);
      thisController.newDomainFormRef.reset();
    }
  }


  addChildRow = (props, e) => {
    this.setState({ currentParentId: props.original.id })
    this.setState({ currentParentName: props.original.name })
    this.setState({ showAddChildPopup: true })
  }

  closeAddDomainPopup = () => {
    this.state.errors = {};
    this.state.fields = {};
    this.setState({ showAddDomainPopup: false })
    this.newDomainFormRef.reset();
  }

  closeAddChildDomain = () => {
    this.state.errors = {};
    this.state.fields = {};
    this.setState({ showAddChildPopup: false })
    this.childFormRef.reset();
  }

  saveChildDomainApi = (e) => {
    let data = {
      "name": this.state.fields.childName,
      "description": this.state.fields.childDescription,
      "projectId": localStorage.getItem("currentProjectId"),
      "parentId": this.state.currentParentId
    }
    if (this.validateChildDomainInputsInForm()) {
      let thisController = this;
      $.ajax({
        url: "/api/project-categories",
        type: 'POST',
        async: false,
        headers: {
          "Authorization": "Bearer" + localStorage.getItem("access_token"),
          "Content-Type": "application/json"
        },
        data: JSON.stringify(data),
        success: function (res) {
          if (res.success === true) {
            thisController.fetchDomainsOfTheProjectApi();
            thisController.state.showAddChildPopup = false;
            thisController.setState(thisController.state);
            thisController.notifyChildDomainAdded();
          } else {
            thisController.notifyFailToLoadDomain(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        }
      });
      thisController.state.errors = {};
      thisController.state.fields = {};
      thisController.setState(thisController.state);
      thisController.childFormRef.reset();
    }
  }

  indent = (props) => {
    var space = " ";
    for (var i = 0; i < props.row._nestingLevel; i++) {
      space += " \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0";
    }
    return space;
  }

  validateDomainInputsInForm = () => {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["name"] || fields["name"].trim() == "") {
      formIsValid = false;
      errors["name"] = "*Please enter name of Domain";
    }

    if (!fields["description"] || fields["description"].trim() == "") {
      formIsValid = false;
      errors["description"] = "*Please enter description of Domain";
    }

    this.setState({
      errors: errors
    });
    return formIsValid;
  }

  validateChildDomainInputsInForm = () => {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["childName"] || fields["childName"].trim() == "") {
      formIsValid = false;
      errors["name"] = "*Please enter name of Domain";
    }

    if (!fields["childDescription"] || fields["childDescription"].trim() == "") {
      formIsValid = false;
      errors["description"] = "*Please enter description of Domain";
    }

    this.setState({
      errors: errors
    });
    return formIsValid;
  }

  validateNameOfDomain = (props) => {
    let fields = props.target.value;
    let errors = {};
    let formIsValid = true;

    if (fields == "" || fields == " ") {
      formIsValid = false;
      errors["name"] = "*Please enter name of Domain";
    }

    this.setState({
      errors: errors
    });
    return formIsValid;
  }

  validateDescOfDomain = (props) => {
    let fields = props.target.value;
    let errors = {};
    let formIsValid = true;

    if (fields == "" || fields == " ") {
      formIsValid = false;
      errors["description"] = "*Please enter description of Domain";
    }

    this.setState({
      errors: errors
    });
    return formIsValid;
  }

  editAddedDomain = (props) => {
    var thisController = this;
    thisController.state.inEditState = true;
    thisController.state.isRefreshed = true;
    thisController.state.disableAddSubCat = true;
    thisController.state.editedId = props.original.id;
    thisController.setState(thisController.state);
  }

  notifyEmptyFields() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Please fill all the fields</b>, {
      position: "top-center"
    });
  }

  notifySameIdAndParentId = (message) => {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;{message}</b>, {
      position: "top-center"
    });
  }

  validateDomainBeforeUpdation(name, description, props) {
    if (name.trim() == "" || description.trim() == "") {
      this.notifyEmptyFields();
      return false;
    } else if (props.original.id == props.original.parentId) {
      this.notifySameIdAndParentId("Please select valid parent");
      return false;
    } else {
      return true;
    }

  }

  updateDomainOfTheProjectApi = (props, e) => {
    let thisController = this;
    props.original.name = document.getElementById("name" + props.original.id).innerText;
    props.original.description = document.getElementById("description" + props.original.id).innerText;
    this.setState(this.state);
    if (this.validateDomainBeforeUpdation(props.original.name, props.original.description, props)) {
      let updatedData = {
        "id": props.original.id,
        "name": props.original.name,
        "description": props.original.description,
        "projectId": localStorage.getItem("currentProjectId"),
        "parentId": props.original.parentId
      };

      $.ajax({
        url: "/api/project-categories",
        async: false,
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(updatedData),
        processData: false,
        success: function (res) {
          if (res.success === true) {
            thisController.state.editedId = "-1";
            thisController.state.isRefreshed = true;
            thisController.state.disableAddSubCat = false;
            thisController.setState(thisController.state);
            thisController.fetchDomainsOfTheProjectApi();
            thisController.notifyDomainUpdated();
          } else {
            thisController.notifyFailToLoadDomain(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        }
      });
    }
  }

  deleteDomainApi = (id) => {
    let thisController = this;
    $.ajax({
      url: "/api/project-categories/" + id,
      async: false,
      method: 'DELETE',
      headers: {
        "Authorization": "Bearer" + localStorage.getItem("access_token")
      },

      success: function (res) {
        if (res.success === true) {
          thisController.setState({ hideDeletePopup: false });
          thisController.fetchDomainsOfTheProjectApi();
          thisController.notifyDomainDelete();
        } else {
          thisController.notifyFailToLoadDomain(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  notifyDomainDelete() {
    toast.dismiss();
    toast(<b>
      <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
      &nbsp;&nbsp;Child Domain Deleted Successfully</b>, {
      position: "top-center"
    });
  }

  notifyFailToLoadDomain(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }

  refreshData = (id) => {

    this.state.isRefreshed = true;
    this.state.disableAddSubCat = false;
    this.state.expanded = {};
    this.setState(this.state);
    this.fetchDomainsOfTheProjectApi();
  }

  handleTableDomainChange = (props, e) => {
    props.original.parentId = e.target.value;
    props.original.name = document.getElementById("name" + props.original.id).innerText;
    props.original.description = document.getElementById("description" + props.original.id).innerText;
    this.setState(this.state);
  }

  render() {
    const { data } = this.state;

    if (this.state.isRefreshed) {
      this.columns = this.columns = [
        {
          width: 35,
          expander: true,
          Expander: row => {
            const needsExpander =
              row.original._subRows.length >= 1 ? true : false;
            return needsExpander ? (
              <ReactTable.defaultProps.ExpanderComponent {...row} />
            ) : null;
          },
          Cell: null
        },
        {
          Header: <b>Name</b>,
          accessor: 'name',
          sortable: false,
          Cell: props => (<div className="input"
            style={{ width: '98%', padding: '8px', border: (props.original.id == null || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == null) ? '2px' : 'none', paddingLeft: '2px' }}
          >
            <span>{this.indent(props)}</span>
            <span type="text" style={{ width: '98%', padding: '8px' }}
              contentEditable={(props.original.id == null) ? true : (props.original.id == this.state.editedId)}
              suppressContentEditableWarning
              id={"name" + props.original.id}>
              {props.original.name}</span>
          </div>
          )
        },
        {
          Header: <b>Description</b>,
          accessor: 'description',
          sortable: false,
          Cell: props => (<div className="input"
            style={{ width: '98%', padding: '8px', border: (props.original.id == null || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == null) ? '2px' : 'none', paddingLeft: '2px' }}
            contentEditable={(props.original.id == null) ? true : (props.original.id == this.state.editedId)}
            suppressContentEditableWarning
            type="text" id={"description" + props.original.id}
          >{props.original.description}</div>)
        },
        {
          Header: <b>Parent Domain</b>,
          accessor: 'parentDomain',
          sortable: false,
          width: 350,
          show: this.state.inEditState,
          Cell: props => (
            <div className="container-fluid" style={{ textAlign: "right" }}>
              <select type="select-multiple" className="input-group form-control select2 "
                value={props.original.parentId} id={"parent-domain" + props.index}
                onChange={(e) => this.handleTableDomainChange(props, e)}
                style={{ background: 'white', border: 'none' }}
                disabled={(props.original.id == "") ? false : props.original.id != this.state.editedId}>
                {this.dropDownData.map(domain => (
                  <option hidden={domain.domainId == "00000000-0000-0000-0000-000000000000"} key={domain.domainId} value={domain.domainId} >
                    {domain.domain}
                  </option>
                ))}
              </select>
            </div>)
        },
        {
          width: 250,
          Header: <b>Action</b>,
          sortable: false,
          Cell: props => {
            const projectRole = localStorage.getItem('PROJECT_ROLE');
            const isProjectAdmin = projectRole === 'PROJECT_ADMIN';

            return (

              <div id="action">
                <div style={{ marginTop: "-6px" }}>
                  <p>
                    {/* Add Sub Categories Button */}
                    <button
                      className="btn2 table-action-button"
                      onClick={(e) => { this.addChildRow(props, e); }}
                      hidden={props.original.id === undefined}
                      disabled={!isProjectAdmin || this.state.disableAddSubCat}
                      style={{ opacity: (!isProjectAdmin) ? 0.65 : 1 }}
                    >
                      Add Sub Categories
                    </button>
                    <b />

                    {/* Edit/Save Button */}
                    <button
                      style={{
                        backgroundColor: "#ffffff",
                        border: "none",
                        opacity: (!isProjectAdmin) ? 0.65 : 1
                      }}
                      hidden={(props.original.parentId === "00000000-0000-0000-0000-000000000000" &&
                        props.original.name.toLocaleLowerCase() === this.state.projectGlobalDomain.toLocaleLowerCase())}
                      title={props.original.id === undefined ? "Save" : (props.original.id !== this.state.editedId ? "Edit" : "Save")}
                      disabled={!isProjectAdmin}
                    >
                      <img
                        className="img-responsive"
                        id="editOrSave"
                        style={{
                          marginTop: '8px', backgroundColor: '#282a65',
                          borderRadius: '5px', padding: '1px'
                        }}
                        src={(props.original.id !== this.state.editedId) ? this.editImageSrc : this.saveImageSrc}
                        onClick={(e) => {
                          if (isProjectAdmin) {
                            if (props.original.id === this.state.editedId) {
                              this.updateDomainOfTheProjectApi(props, e);
                            } else {
                              this.editAddedDomain(props, e);
                            }
                          }
                        }}
                      />
                    </button>

                    {/* Delete Button */}
                    <button
                      style={{
                        backgroundColor: "#ffffff",
                        border: "none",
                        opacity: (!isProjectAdmin) ? 0.65 : 1
                      }}
                      hidden={(props.original.parentId === "00000000-0000-0000-0000-000000000000" &&
                        props.original.name.toLocaleLowerCase() === this.state.projectGlobalDomain.toLocaleLowerCase()) ||
                        props.original._subRows.length >= 1}
                      title="Delete"
                      disabled={!isProjectAdmin}
                    >
                      <img
                        className="img-responsive"
                        src="./assets/images/baseline_delete_white_24dp.png"
                        style={{
                          marginTop: '6px',
                          backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                        }}
                        onClick={() => {
                          if (isProjectAdmin) {
                            if (props.original.id === undefined) {
                              this.fetchDomainsOfTheProjectApi();
                            } else {
                              this.setState({
                                hideDeletePopup: true,
                                propsId: props.original.id
                              });
                            }
                          }
                        }}
                      />
                    </button>
                  </p>
                </div>
              </div>

            )
          }
        }
      ]
    }

    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={!(this.state.showLoader)}
          height={300}
          width={50}
          style={{ textAlign: 'center' }} />
        <div style={{ display: this.state.showLoader ? 'block' : 'none' }}>
          {/* for toaster */}
          <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

          {/* for reactTable */}
          <link rel="stylesheet" href="./assets/css/React_Table_CSS/react-table.css" />
          <link rel="stylesheet" href="./assets/css/react-table-height.css" />

          {/*links for css files used for popup */}
          <link href="./assets/css/ej2-base.css" rel="stylesheet" />
          <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="./assets/css/screenResolution.css" rel="stylesheet" />

          <ToastContainer className="Toast-at-center" />
          <div className="row" style={{ marginTop: "-20px" }}>
            <div className="col-sm-5">

              <h6 className="nav-item" style={{ color: '#282a65', marginTop: '20px', marginLeft: '10px' }}>Domains</h6>
            </div>
            <div className="col-sm-7" Align="right">
              {/* Refresh Page */}
              <button className="btn action-button" title="Refresh"
                onClick={this.refreshData}>
                <img src="./assets/images/refresh_white_24dp.png" />
              </button>


            </div>
            {/* </div> */}

          </div>

          <ReactTable
            data={data}
            style={{ backgroundColor: "white" }}
            columns={this.columns}
            defaultPageSize={10}
            pageSizeOptions={[5, 10, 15]}
            onExpandedChange={(expanded, index, event) => {
              this.setState({ expanded });
            }}
            expanded={this.state.expanded}
          />
        </div>



        {/* New Domain Popup */}
        <div className="modal" style={{ display: this.state.showAddDomainPopup ? 'block' : 'none' }}>
          <div className="modal-dialog">
            <div className="modal-content" style={{ height: "100%" }}>
              <div className="modal-header noBorder">
                <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={this.closeAddDomainPopup}>
                  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                  </svg>
                </button>
              </div>
              <div className="modal-body">
                <form ref={(el) => this.newDomainFormRef = el}>
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Name</label>
                    <div className="col-sm-8">
                      <input type="text" name="name" style={{ width: "92%" }}
                        className="form-control-plaintext" onChange={this.handleChangeForInputData}
                        onBlur={this.validateNameOfDomain} />
                    </div>
                  </div>
                  <div>
                    <span className="errorMsg" name="name" style={{ color: 'red' }}>{this.state.errors.name} </span>
                  </div> <br />
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Description</label>
                    <div className="col-sm-8">
                      <textarea type="text" name="description" className="form-control"
                        style={{ borderColor: "rgba(192,192,192,0.3)", borderWidth: "1px" }}
                        onBlur={this.validateDescOfDomain} onChange={this.handleChangeForInputData} />
                    </div>
                  </div>
                  <div>
                    <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.description} </span>
                  </div> <br />
                  <div className="modal-footer noBorder">
                    <button type="button" className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal" onClick={this.saveDomainApi}>Done</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>


        {/* Child Domain Popup */}
        <div className="modal" style={{ display: this.state.showAddChildPopup ? 'block' : 'none' }}>
          <div className="modal-dialog">
            <div className="modal-content" style={{ height: "100%" }}>
              <div className="modal-header noBorder">
                <div style={{ paddingTop: "5px", textAlign: "center", color: "#A9A9A9" }}>Child name of {this.state.currentParentName}</div>
                <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={this.closeAddChildDomain}>
                  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                  </svg>
                </button>
              </div><br /><br />
              <div className="modal-body">
                <form ref={(el) => this.childFormRef = el}>
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Name</label>
                    <div className="col-sm-8">
                      <input type="text" name="childName" style={{ width: "92%" }}
                        className="form-control-plaintext" onChange={this.handleChangeForInputData}
                        onBlur={this.validateNameOfDomain} />
                    </div>
                  </div>
                  <div>
                    <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.name} </span>
                  </div> <br />
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Description</label>
                    <div className="col-sm-8">
                      <textarea type="text" name="childDescription" className="form-control"
                        style={{ borderColor: "rgba(192,192,192,0.3)", borderWidth: "1px" }}
                        onBlur={this.validateDescOfDomain} onChange={this.handleChangeForInputData} />
                    </div>
                  </div>
                  <div>
                    <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.description} </span>
                  </div> <br />
                  <div className="modal-footer noBorder">
                    <button type="button" className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal" onClick={this.saveChildDomainApi}>Done</button>
                  </div>
                </form>
              </div>
            </div>
            {/*Dialog Component For Deletion Confirmation*/}
            <DialogComponent width='400px' animationSettings={this.settings}
              header='Domains' showCloseIcon={true} buttons={this.buttons}
              ref={dialog => this.dialogInstance = dialog}
              visible={this.state.hideDeletePopup} close={this.dialogClose}>
              <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                content="" />&nbsp;Do you want to delete this Child Domain?<br />Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>

          </div>
        </div>

      </div >

    );
  }
}

export default Domains;


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/Domains.js